import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

const Protected = (props) => {

   const history = useNavigate()
   const { Component } = props

   useEffect(() => {
      const login = localStorage.getItem("login")
      if (!login) {
         localStorage.setItem("loginStatus", "Por favor, inicie sesión.")
         history("/")
         history(0)
      }

   }, []);

   return <Component />
}

export default Protected